import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ideal-oidc-callback-page',
  standalone: true,
  imports: [],
  templateUrl: './oidc-callback.component.html',
  styleUrl: './oidc-callback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OidcCallbackPageComponent {}
